import { useState, useEffect } from "react";

export const useLikedCases = () => {
  const [likedCases, setLikedCases] = useState<string[]>([]);

  useEffect(() => {
    const storedLikedCases = getCookie("likedCases");
    if (storedLikedCases) {
      setLikedCases(JSON.parse(storedLikedCases));
    }
  }, []);

  const handleLike = (caseId: string) => {
    const newLikedCases = [...likedCases, caseId];
    setLikedCases(newLikedCases);
    setCookie("likedCases", JSON.stringify(newLikedCases), 1);
  };

  const handleUnlike = (caseId: string) => {
    const newLikedCases = likedCases.filter((id) => id !== caseId);
    setLikedCases(newLikedCases);
    setCookie("likedCases", JSON.stringify(newLikedCases), 1);
  };

  return { likedCases, handleLike, handleUnlike };
};

const setCookie = (name: string, value: string, days: number) => {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
};

const getCookie = (name: string) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};
